var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useVerticalExternalTimelineProcessController, } from "../../../../useVerticalTimelineProcessController";
export function TimelineDescriptionDotFinishedDefault(_a) {
    var data = _a.data, step = _a.step;
    var _b = useVerticalExternalTimelineProcessController({
        data: data,
    }), formatDateToBrazilianPattern = _b.formatDateToBrazilianPattern, findAttributeDateValue = _b.findAttributeDateValue;
    return (_jsxs("span", __assign({ className: "text-sm text-[#262626}" }, { children: ["realizado em:", " ", formatDateToBrazilianPattern(findAttributeDateValue(step.key))] })));
}
